export const AFTER_MESSAGES = 'AFTER'
export const BEFORE_MESSAGES = 'BEFORE'
export const AROUND_MESSAGES = 'AROUND'
